import { firmClientKeys } from '../FirmClient';

export const financialNextStepKeys = {
  financialNextSteps: (householdID?: string) => [
    'financialNextSteps',
    ...firmClientKeys.household(householdID),
  ],
};
